import ReactNodeError from "src/shared/objects/ReactNodeError";
import type { ReactNode } from "react";
import type { AxiosResponse } from "axios";

export class ResponseError extends ReactNodeError {
  constructor(
    public response: AxiosResponse,
    reactNode: ReactNode,
    message?: string,
  ) {
    super(reactNode, message);
  }
}
